<template>
  <table class="table table-sm cst">
    <thead>
      <tr>
        <th>Наименование</th>
        <th class="cst__num">Стоимость</th>
        <th>Состояние</th>
        <th class="cst__actions">Действия</th>
      </tr>
    </thead>
    <tbody>
      <tr v-if="rows.length === 0">
        <td colspan="4" class="text-muted text-center py-3">Записей нет</td>
      </tr>
      <tr v-for="row in rows" :key="row.id" class="cst__row" :class="{ 'cst__row--archived': archived(row) }">
        <td>{{ row.title }}<span v-if="archived(row)" class="cst__tag">архив</span></td>
        <td class="cst__num">{{ price(row) }}</td>
        <td><span :class="archived(row) ? 'text-muted' : 'text-success'">{{ archived(row) ? 'Архив' : 'Активен' }}</span></td>
        <td class="cst__actions">
          <button type="button" class="btn btn-sm btn-outline-secondary cst__edit" :disabled="locked(row)" @click="$emit('edit', row)">Изменить</button>
          <button v-if="archived(row)" type="button" class="btn btn-sm btn-outline-secondary cst__unarchive" :disabled="locked(row)" @click="$emit('unarchive', row)">Вернуть</button>
          <button v-else type="button" class="btn btn-sm btn-outline-secondary cst__archive" :disabled="locked(row)" @click="$emit('archive', row)">В архив</button>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import { priceOf, isArchived, formatRub } from '@/components/management/dispatcher/catalogPayload';

export default {
  name: 'ConsumablesTable',
  props: {
    rows: { type: Array, default: () => [] },
    pendingIds: { type: Array, default: () => [] },
    disabled: { type: Boolean, default: false },
  },
  methods: {
    archived: (row) => isArchived(row),
    price: (row) => formatRub(priceOf(row)),
    locked(row) { return this.disabled || this.pendingIds.includes(row.id); },
  },
};
</script>

<style scoped lang="scss">
.cst { margin-bottom: 0; font-size: 13px; }
.cst th { font-size: 10.5px; letter-spacing: .08em; text-transform: uppercase; color: #9aa09b; border-top: 0; white-space: nowrap; }
.cst td { vertical-align: middle; }
.cst__num { text-align: right; white-space: nowrap; }
.cst__actions { text-align: right; white-space: nowrap; width: 1%; button + button { margin-left: 6px; } }
.cst__row--archived td { color: #8b918c; }
.cst__tag { display: inline-block; margin-left: 8px; padding: 1px 6px; border-radius: 6px; background: #f4f5f1; color: #8b918c; font-size: 10.5px; text-transform: uppercase; letter-spacing: .06em; }
</style>
